import {BaSeButton, BaSeInputList, BaSeOptionPicker, BaSeRadio,} from "@base/react"
import {useCallback, useEffect, useMemo, useState} from "react"
import {converterSnakeToCamelCase, eventTag, getCurrentCNPJ, uuid,} from "../../services/utils"
import PagePlanningsStructure, {TabsAndOrderBy,} from "../../components/page-plannings-structure"
import {useApp} from "../../hooks/use-app"
import moment from "moment/moment"
import Loading from "../../components/loading"
import EmptyPlannings from "../../components/empty-plannings"
import ListPlanning from "./components/listPlannings"
import Archived from "./components/archived"
import ApiPlannings from "../../services/planning"
import {optionsPeriod} from "../../mocks/consts"
import {toast} from "react-toastify";
import ToastContent from "../../components/toastContent";
import ModalDefault from "../../components/modals/modal-default";
import {useNavigate} from "react-router-dom";
import "./index.scss"

const apiPlannings = ApiPlannings()

const event = {
  name: "monitoring",
  category: "monitoramento",
  action: "click",
}

const PAGE_SIZE = 8 //8
const DEFAULT_ORDER_BY = "sort_by_created_at=desc"
const INITIAL_LIST_STATE = {
  count: 0,
  results: [],
  loading: false,
}
const INITIAL_FILTERS = {
  searchList: [],
  period: null,
  isShared: null,
  orderBy: DEFAULT_ORDER_BY,
}

const getMonitoringTitle = (item) => {
  return item?.title || item?.planTitle || item?.plan_title || item?.name || `Monitoramento ${item?.id || ""}`.trim()
}

const Monitoring = ({ account }) => {
  const {
    companies,
  } = useApp()
  const currentCnpj = useMemo(() => {
    return getCurrentCNPJ(companies) || null
  }, [companies])
  const navigate = useNavigate()

  const document = currentCnpj || account?.cpf

  const [loading, setLoading] = useState(true)
  const [isLoadingModal, setIsLoadingModal] = useState(false)
  const [searchInput, setSearchInput] = useState("")
  const [filters, setFilters] = useState(INITIAL_FILTERS)

  const [listPlanning, setListPlanning] = useState(INITIAL_LIST_STATE)
  const [listArchived, setListArchived] = useState(INITIAL_LIST_STATE)

  const [showCreateModal, setShowCreateModal] = useState(false)
  const [monitoringList, setMonitoringList] = useState([])
  const [selectedMonitoringId, setSelectedMonitoringId] = useState(null)

  const [updatePlanning, setUpdatePlanning] = useState(false)
  const [updateArchived, setUpdateArchived] = useState(false)
  const [openCardId, setOpenCardId] = useState(null)

  const [paramsPlanning, setParamsPlanning] = useState({
    document: document,
    page: 1,
    page_size: PAGE_SIZE,
  })
  const [paramsArchived, setParamsArchived] = useState({
    document: document,
    page: 1,
    page_size: PAGE_SIZE,
  })
  const searchParam = useMemo(() => {
    if (!filters.searchList.length) return null

    return filters.searchList
      .map((item) => item.label)
      .join(",")
  }, [filters.searchList])
  const periodParams = useMemo(() => {
    if (!filters.period?.monthAmt) {
      return {
        start_date: null,
        end_date: null,
      }
    }

    return {
      start_date: moment()
        .subtract(filters.period.monthAmt, "months")
        .format("YYYY-MM-DD"),
      end_date: moment().format("YYYY-MM-DD"),
    }
  }, [filters.period])

  const resetPlanningPage = () => {
    setParamsPlanning((prev) => ({
      ...prev,
      page: 1,
    }))
  }
  const resetArchivedPage = () => {
    setParamsArchived((prev) => ({
      ...prev,
      page: 1,
    }))
  }
  const resetAllPages = () => {
    resetPlanningPage()
    resetArchivedPage()
  }

  const setPlanningLoading = (value = true) => {
    setListPlanning((prev) => ({
      ...prev,
      loading: value,
    }))
  }
  const setArchivedLoading = (value = true) => {
    setListArchived((prev) => ({
      ...prev,
      loading: value,
    }))
  }
  const setAllLoading = (value = true) => {
    setPlanningLoading(value)
    setArchivedLoading(value)
  }

  const forceUpdateListPlanning = () => {
    setUpdatePlanning(true)

    setTimeout(() => {
      setUpdatePlanning(false)
    }, 1000)
  }
  const forceUpdateListArchived = () => {
    setUpdateArchived(true)

    setTimeout(() => {
      setUpdateArchived(false)
    }, 1500)
  }

  const toggleSearchTags = (item) => {
    let nextTags = [...filters.searchList]

    if (typeof item !== "string") {
      nextTags = nextTags.filter((tag) => tag.id !== item.id)
    } else {
      const value = item.trim()

      if (!value) return

      nextTags.push({
        id: uuid(),
        label: value,
      })

      eventTag(
        event.name,
        event.category,
        "submit",
        `Filtro por pesquisa: ${value}`
      )
    }

    setSearchInput("")

    setFilters((prev) => ({
      ...prev,
      searchList: nextTags,
    }))

    resetAllPages()
    setAllLoading(true)
  }

  const handlePeriodChange = (selected) => {
    const period = selected?.[0] || null

    setFilters((prev) => ({
      ...prev,
      period,
    }))
    resetAllPages()
    setAllLoading(true)

    eventTag(
      event.name,
      event.category,
      "submit",
      `Filtro por período: ${period?.label || "Todos"}`
    )
  }

  const handleOrderByChange = useCallback((filter) => {
    const statusMap = {
      all: null,
      my_monitoring: false,
      shared: true,
    }
    const statusMapLabel = {
      all: "Todos",
      my_monitoring: "Meus monitoramentos",
      shared: "Compartilhados",
    }

    setFilters((prev) => {
      const nextIsShared = statusMap[filter.tab]
      const nextOrderBy = filter.orderBy || DEFAULT_ORDER_BY

      eventTag(
        event.name,
        event.category,
        "submit",
        `Filtro por: ${statusMapLabel[filter.tab]}`
      )

      if (
        prev.isShared === nextIsShared &&
        prev.orderBy === nextOrderBy
      ) {
        return prev
      }

      return {
        ...prev,
        isShared: nextIsShared,
        orderBy: nextOrderBy,
      }
    })

    setParamsPlanning((prev) => {
      if (prev.page === 1) return prev

      return {
        ...prev,
        page: 1,
      }
    })

    setPlanningLoading(true)
  }, [])
  const loadMore = (type = "planning") => {
    eventTag(
      "click-button",
      event.category,
      event.action,
      `Carregar mais planejamentos`
    )

    if (type === "planning") {
      if (listPlanning.loading) return

      setPlanningLoading(true)
      setParamsPlanning((prev) => ({
        ...prev,
        page: prev.page + 1,
      }))

      return
    }

    if (type === "archived") {
      if (listArchived.loading) return

      setArchivedLoading(true)
      setParamsArchived((prev) => ({
        ...prev,
        page: prev.page + 1,
      }))
    }
  }
  const handleRemovedUserFromPlanning = (planningId, userId) => {
    setListPlanning((prevList) => ({
      ...prevList,
      results: prevList?.results.map((planning) =>
        planning.id === planningId
          ? {
            ...planning,
            invites: planning.invites.filter(
              (invite) => invite.id !== userId
            ),
          }
          : planning
      ),
    }))
  }
  const fnCallbacksCard = ({ type, status }) => {
    if (type === "archive" || type === "unarchive") {
      if (status === "success") {
        resetPlanningPage()
        setParamsArchived({
          document: document,
          page: 1,
          page_size: PAGE_SIZE,
        })
      }

      if (status === "finalized") {
        setLoading(false)
        forceUpdateListPlanning()
        forceUpdateListArchived()
      }

      return
    }
    if (type === "duplicate" && status === "success") {
      resetPlanningPage()
      return
    }
    if (type === "monitor" && status === "finalized") {
      forceUpdateListPlanning()
    }
  }

  const getListMonitoringAvailable = async () => {
    try {
      const {data} = await apiPlannings.canMonitored(currentCnpj)
      setMonitoringList(data || [])
    } catch (error) {
      console.warn(error)
      setMonitoringList([])
      toast.error(
        <ToastContent
          title="Erro"
          description="Não foi possível carregar os monitoramentos disponíveis."
        />
      )
    }
  }

  const closeCreateMonitoringModal = () => {
    setShowCreateModal(false)
    setSelectedMonitoringId(null)
  }
  const handleCreateMonitoring = async () => {
    setShowCreateModal(true)
    eventTag(
      event.name,
      event.category,
      event.action,
      "Criar monitoramento"
    )
  }
  const handleConfirmMonitoring = () => {
    if (!selectedMonitoringId) return

    setIsLoadingModal(true)
    apiPlannings
      .monitorPlanning(selectedMonitoringId)
      .then((res) => {
        const {data} = res
        toast.success(
          <ToastContent
            title="Sucesso!"
            description="Operação realizada com sucesso."
          />
        )

        eventTag(
          event.name,
          "post_credit",
          "submit",
          `Iniciando monitoramento: ${data?.title}`
        )

        navigate(`/planejamento/${data?.id}/pos-credito`)
      })
      .catch((err) => {
        console.warn(err)
        if (err.message.includes("Planejamento já monitorado")) {
          const planId = err.message.split(" ")[4].replace("ID:", "")
          navigate(`/planejamento/${planId}/pos-credito`)
        } else {
          toast.error(
            <ToastContent
              title="Erro"
              description="Não foi possível realizar a operação."
            />
          )
        }
      })
      .finally(() => {
        setIsLoadingModal(false)
        closeCreateMonitoringModal()
      })
  }

  const handleSearchInputEnter = (event) => {
    event.preventDefault()
    event.currentTarget
      ?.closest(".BaSe--input-list-container")
      ?.querySelector("button")
      ?.click()
  }

  const layoutFilters = (
    <>
      <BaSeInputList
        value={searchInput}
        onChange={setSearchInput}
        placeholder="Pesquise por nome do planejamento"
        isDisabled={listPlanning.loading || listArchived.loading}
        buttonAction={toggleSearchTags}
        typeButton="base-icon"
        nameButton="search"
        valueButton=""
        onSpecificKeyDown={[
          {
            listenerKey: "Enter",
            callback: handleSearchInputEnter,
          },
        ]}
        listItems={{
          direction: "row",
          columnNum: 1,
          gap: "8px",
          valuesList: filters.searchList,
          listActions: [
            {
              size: "small",
              sizeIcon: "small",
              ActionisDisabled: false,
              nameIcon: "close",
              color: "#005EB8",
              listAction: toggleSearchTags,
            },
          ],
        }}
      />
      <div className="wrapper-select with-icon calendar">
        <BaSeOptionPicker
          label="Período"
          values={optionsPeriod}
          emptyValueLabel="Selecione"
          enableSelectAll={false}
          maxOptionsSelected={1}
          withFilterText={false}
          initialSelectedValuesId={[0]}
          onChange={handlePeriodChange}
          isDisabled={listPlanning.loading || listArchived.loading}
        />
      </div>
    </>
  )
  const layoutContent = (
    <>
      <TabsAndOrderBy
        tabs={[
          {
            label: "Todos",
            count: listPlanning?.count || 0,
            action: "all",
          },
          {
            label: "Meus monitoramentos",
            action: "my_monitoring",
          },
          {
            label: "Compartilhados",
            action: "shared",
          },
        ]}
        onFilter={handleOrderByChange}
        isDisabled={listPlanning.loading || listArchived.loading}
        event={event}
      />

      <div className="list-planning">
        {loading ? (
          <div className="wrapper-loading-small">
            <Loading small />
          </div>
        ) : !listPlanning.count && !listArchived.count ? (
          <EmptyPlannings title="Você ainda não tem monitoramento"
                          subtitle="Crie seu primeiro monitoramento e comece a organizar">
            <BaSeButton
              color="#005EB8"
              value="Criar monitoramento"
              isDisabled={!monitoringList.length}
              onClick={handleCreateMonitoring}
            />
          </EmptyPlannings>
        ) : (
          <>
            <div className="list-planning">
              <ListPlanning
                event={event}
                account={account}
                listPlanning={listPlanning}
                updatePlanning={updatePlanning}
                openCardId={openCardId}
                setOpenCardId={setOpenCardId}
                handleRemovedUserFromPlanning={handleRemovedUserFromPlanning}
                loadMore={() => loadMore("planning")}
                callbackCardFinalized={(e) => fnCallbacksCard(e)}
              />
            </div>

            <div className="archived-planning">
              <Archived
                event={event}
                listArchived={listArchived}
                updateArchived={updateArchived}
                loadMore={() => loadMore("archived")}
                callbackCardFinalized={(e) => fnCallbacksCard(e)}
              />
            </div>
          </>
        )}
      </div>
    </>
  )

  useEffect(() => {
    let isMounted = true

    const fetchPlanning = async () => {
      const isLoadMore = paramsPlanning.page > 1

      setPlanningLoading(true)

      const apiParams = {
        ...paramsPlanning,
        ...periodParams,
      }

      if (searchParam) {
        apiParams.title = searchParam
      }
      if (filters.isShared !== null) {
        apiParams.is_shared = filters.isShared
      }
      if (filters.orderBy) {
        const [key, value] = filters.orderBy.split("=")
        apiParams[key] = value
      }

      try {
        const { data } = await apiPlannings.listPostCredit(apiParams)

        if (!isMounted) return

        const results = data.results.map((item) =>
          converterSnakeToCamelCase(item)
        )
        setListPlanning((prev) => ({
          ...data,
          loading: false,
          results: isLoadMore
            ? [...(prev.results || []), ...results]
            : results,
        }))
      } catch (err) {
        console.warn(err)

        if (isMounted) {
          setPlanningLoading(false)
        }
      } finally {
        if (isMounted) {
          setLoading(false)
        }
      }
    }

    fetchPlanning()

    return () => {
      isMounted = false
    }
  }, [
    paramsPlanning,
    periodParams,
    searchParam,
    filters.isShared,
    filters.orderBy,
  ])
  useEffect(() => {
    let isMounted = true

    const fetchArchived = async () => {
      const isLoadMore = paramsArchived.page > 1

      setArchivedLoading(true)

      const apiParams = {
        ...paramsArchived,
        ...periodParams,
        archived: true,
      }

      if (searchParam) {
        apiParams.title = searchParam
      }

      try {
        const { data } = await apiPlannings.listPostCredit(apiParams)

        if (!isMounted) return

        const results = data.results.map((item) =>
          converterSnakeToCamelCase(item)
        )

        setListArchived((prev) => ({
          ...data,
          loading: false,
          results: isLoadMore
            ? [...(prev.results || []), ...results]
            : results,
        }))
      } catch (err) {
        console.warn(err)

        if (isMounted) {
          setArchivedLoading(false)
        }
      }
    }

    fetchArchived()

    return () => {
      isMounted = false
    }
  }, [
    paramsArchived,
    periodParams,
    searchParam,
  ])
  useEffect(() => {
    setLoading(true)
    setSearchInput("")
    setFilters(INITIAL_FILTERS)
    setListPlanning(INITIAL_LIST_STATE)
    setListArchived(INITIAL_LIST_STATE)

    setParamsPlanning({
      document: currentCnpj,
      page: 1,
      page_size: PAGE_SIZE,
    })
    setParamsArchived({
      document: currentCnpj,
      page: 1,
      page_size: PAGE_SIZE,
    })

    getListMonitoringAvailable()

    // eslint-disable-next-line
  }, [currentCnpj])

  return (
    <div className="monitoring">
      <ModalDefault
        show={showCreateModal}
        callBackClose={closeCreateMonitoringModal}
        square
        title="Novo monitoramento"
        classCustom="monitoring__modal"
      >
        <div className="monitoring__modal-content">
          {isLoadingModal ? (
              <div className="monitoring-page__modal-loading">
                <Loading small />
              </div>
            ) : (
              <>
                <p>
                  Selecione o planejamento base para transformar em monitoramento
                </p>
                <div className="monitoring__modal-list">
                  {monitoringList.map((item, index) => (
                    <BaSeRadio
                      key={item?.id || `${getMonitoringTitle(item)}-${index}`}
                      checked={selectedMonitoringId === (item?.id)}
                      color={"#3b63f3"}
                      id={1}
                      label={getMonitoringTitle(item)}
                      name="monitoring-base-plan"
                      onChange={() => setSelectedMonitoringId(item?.id)}
                      shape="circle"
                      size="medium"
                    />
                  ))}
                </div>
              </>
          )}

          <div className="monitoring__modal-actions">
            <BaSeButton
              color="#2E5DE6"
              value="Confirmar"
              isDisabled={!selectedMonitoringId}
              onClick={handleConfirmMonitoring}
            />
          </div>
        </div>
      </ModalDefault>

      <div className="container">
        <PagePlanningsStructure
          title="Monitoramento"
          filters={layoutFilters}
          button={
            <BaSeButton
              color="#005EB8"
              value="Criar monitoramento"
              isDisabled={!monitoringList.length}
              onClick={handleCreateMonitoring}
            />
          }
        >
          {layoutContent}
        </PagePlanningsStructure>
      </div>
    </div>
  )
}

export default Monitoring
